import { NEW_BOOKING_FAILURE, NEW_BOOKING_REQUEST, NEW_BOOKING_SUCCESS } from './actionTypes';
import axios from 'axios/index';

export function newBooking(token, event, note, membres, date, groupe, callback1, callback2) {
  let data = {
    note,
    membres,
    groupe,
    date,
  };

  event === 'null' ? undefined : (data.event = event);

  return dispatch => {
    dispatch({ type: NEW_BOOKING_REQUEST });

    return axios({
      url: `${process.env.GATSBY_API_URL}/booking`,
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data,
    })
      .then(response => {
        dispatch({ type: NEW_BOOKING_SUCCESS, payload: response.data });
        callback1();
      })
      .catch(error => {
        dispatch({ type: NEW_BOOKING_FAILURE, payload: error });
        callback2();
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/BookingAction.js